import React from 'react';
import { makeCSS } from '../../utils/makeCSS';
import { Image } from '../atoms/Image';
import { Button } from '../atoms/Button';

export interface ImageGridProps {
  images: any[];
  onClickClose: (img) => void;
}

const useCSS = makeCSS(({ theme }) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(25%, 1fr))',
    gap: theme.spacing[2],
    padding: theme.spacing[2],
    height: '100%',
    width: '100%',
    boxSizing: 'border-box'
  },
  imageContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'border 0.3s ease',
    display: 'flex',
    justifyContent: 'center',
    border: `1px solid ${theme.color.line['02']}`,
    '&:hover': {
      borderColor: theme.color.line['01']
    }
  },
  imageItem: {
    position: 'absolute',
    height: 'inherit',
    width: 'auto',
    '& > div': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  close: {
    position: 'absolute',
    right: theme.spacing[2],
    top: theme.spacing[2]
  }
}));

export const ImageGrid = (props: ImageGridProps) => {
  const { images, onClickClose } = props;
  const classes = useCSS();

  return (
    <div id="image-grid" className={classes.root}>
      {images.map((img) => (
        <div key={img.src} className={classes.imageContainer}>
          <div className={classes.imageItem}>
            <Image {...img} />
          </div>
          <span className={classes.close}>
            <Button iconLeft="close" onClick={() => onClickClose(img)} />
          </span>
        </div>
      ))}
    </div>
  );
};
